//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    slides: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    swiperOptions: {
      slidesPerView: 'auto',
      spaceBetween: 10,
    },
  }),
  computed: {
    swiper() {
      return this.$refs.textSlider.$swiper;
    },
  },
};
